import styled from 'styled-components';
export const FlexColumnDiv = styled.div.withConfig({
  displayName: "commonDiv__FlexColumnDiv",
  componentId: "lauabd-0"
})(["display:flex;flex-direction:column;"]);
export const FlexColumnCenterDiv = styled.div.withConfig({
  displayName: "commonDiv__FlexColumnCenterDiv",
  componentId: "lauabd-1"
})(["display:flex;flex-direction:column;justify-content:center;"]);
export const FlexRowDiv = styled.div.withConfig({
  displayName: "commonDiv__FlexRowDiv",
  componentId: "lauabd-2"
})(["display:flex;flex-direction:row;"]);
export const InfoHeader = styled.div.withConfig({
  displayName: "commonDiv__InfoHeader",
  componentId: "lauabd-3"
})(["padding-bottom:5px;@media print{color:black;}"]);
export const ReactPDFWrapper = styled.div.withConfig({
  displayName: "commonDiv__ReactPDFWrapper",
  componentId: "lauabd-4"
})(["display:", ";"], props => props.reactPdfView ? 'none' : '');
export const FlexRowButtonDiv = styled.div.withConfig({
  displayName: "commonDiv__FlexRowButtonDiv",
  componentId: "lauabd-5"
})(["display:flex;flex-direction:row;justify-content:space-between;width:100%;"]);
export const ReactDatePickerStyles = styled.div.withConfig({
  displayName: "commonDiv__ReactDatePickerStyles",
  componentId: "lauabd-6"
})(["position:", ";z-index:", ";display:inline-flex;align-items:center;vertical-align:middle;max-width:100%;box-sizing:border-box;> div{display:flex;align-items:center;line-height:normal;}div > * .react-datepicker__input-container > input{color:", ";color:", ";border:none;text-align:", ";background:", ";border-bottom:1px solid;width:", ";min-width:", ";margin:", ";box-sizing:border-box;flex-shrink:0;}#progress-notes-picker{height:28px;line-height:28px;margin-top:0;margin-bottom:0;margin-left:2px;margin-right:2px;padding-top:0;padding-bottom:0;}div > * .react-datepicker-popper{z-index:100;position:", ";inset:", ";transform:", ";}"], props => props.position ? props.position : '', props => props.zIndex ? props.zIndex : '', props => !props.color && 'inherit' || props.color === 'primary' && props.theme.palette.text.primary || props.color === 'secondary' && props.theme.palette.text.secondary, props => props.color || 'inherit', props => props.inputTextAlign ? props.inputTextAlign : '', props => props.backgroundColor ? props.backgroundColor : 'transparent', props => props.inputWidth ? props.inputWidth : '', props => props.inputWidth ? props.inputWidth : '', props => props.inputMargin ? props.inputMargin : '', props => props.popperPosition ? `${props.popperPosition} !important` : '', props => props.popperInset ? `${props.popperInset} !important` : '', props => props.popperTransform ? `${props.popperTransform} !important` : '');
/* 

ReactDatePickerAgGridStyles is a wrapper that allows the ReactDatePicker component to properly overlay on top of AgGrid in the UI 

- without this wrapper, the pop-up date picker gets lost behind any AgGrid table in the DOM, and is out of view 

  NOTE: This wrapper makes detail rows render under the entire grid instead of after their master rows.
  This is likely because we're messing with how Ag-Grid renders these by overriding the .ag-row styles.
  Add the portalId="root" prop to <ReactDatePicker> instead of using this element.
*/

export const ReactDatePickerAgGridStyles = styled.div.withConfig({
  displayName: "commonDiv__ReactDatePickerAgGridStyles",
  componentId: "lauabd-7"
})(["div > * .ag-floating-top-container{transform:unset !important;}div > * .ag-center-cols-container{position:relative !important;z-index:0;}div > * .ag-row{position:relative !important;transform:none !important;}div > * .react-datepicker-popper{position:fixed !important;}"]);
export const ErrorText = styled.div.withConfig({
  displayName: "commonDiv__ErrorText",
  componentId: "lauabd-8"
})(["color:", ";margin:0;font-size:0.8rem;text-align:left;font-weight:400;line-height:1.66;"], props => props.theme.palette.error.main);
export const SuggestBoxWrapper = styled.div.withConfig({
  displayName: "commonDiv__SuggestBoxWrapper",
  componentId: "lauabd-9"
})(["", ""], props => props.width ? `width: ${props.width}px;` : `width: 150px;`);